import React from 'react';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import './index.css';
import App from './App';

// Suppress console warnings from browser extensions
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    (args[0].includes('lockdown-install.js') ||
     args[0].includes('Content-Security-Policy') ||
     args[0].includes('inpage.js') ||
     args[0].includes('content.js') ||
     args[0].includes('h1-check.js'))
  ) {
    return; // Suppress browser extension warnings
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

